module.exports = __webpack_public_path__ + "media/reskin-images/icon--note-56c6436b.svg";